export const pageList = [
  { label: 'Trang chủ', link: 'trang-chu' },
  { label: 'Sản phẩm', link: 'san-pham' },
  { label: 'Giới thiệu', link: 'gioi-thieu' },
  // { label: 'Liên hệ', link: 'lien-he' },
]

export const menuList = [
  { label: 'Tất cả sản phẩm', link: 'tat-ca' },
  { label: 'Máy bàn', link: 'may-ban' },
  { label: 'Laptop', link: 'laptop' },
  { label: 'Màng hình', link: 'mang-hinh' },
]
